<template>
    <!-- 警告组件 -->
    <el-alert
    :title="title"
    :type="type"
    :effect="effect"
    :closable="closable"
    :close-text="closeText"
    :show-icon="icon"
    :center="center"
    :description="des"
    @close="close"
    >
        <template v-slot:title>
            <!-- 标题插槽 -->
            <slot name="title"></slot>
        </template>
    </el-alert>
</template>
<script>
export default {
    name:"VelAlert",
    props:{
        type:String,
        effect:String,
        closeText:String,
        isIcon:Boolean,
        isCenter:Boolean,
        isClosable:Boolean,
        des:String,
        title:{
            type:String,
            default:'警告组件'
        }
    },
    data() {
        return {
            icon:false,
            center:false,
            closable:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){ 
            this.isIcon ? this.icon = true : this.icon
            this.isCenter ? this.center = true : this.center
            this.isClosable ? this.closable = true : this.closable
        },
        close(e){
            this.$emit('close',e)
        }
    }
}
</script>